import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/agent")({
  component: lazyRouteComponent(() => import("./-pages/admin.agent")),
  head: () => ({
    meta: [{ title: "Agent · Lecmo Admin" }, { name: "robots", content: "noindex" }],
  }),
});
